var _circle, _path, _circle2, _circle3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourseWalk1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 18.2144,
    r: 17.5,
    fill: "#474C5A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3707 16.4409C16.1387 16.2286 15.8504 16.0715 15.5359 16.0715H14.3926C14.0781 16.0715 13.7898 16.2286 13.5578 16.4409C13.0814 16.877 12.4467 17.143 11.75 17.143C11.1079 17.143 10.5186 16.9171 10.0572 16.5404C9.76731 16.3038 9.38991 16.1297 9.05978 16.3059C8.42917 16.6424 8 17.3068 8 18.0715V23.7144C8 24.8189 8.89543 25.7144 10 25.7144H19.9285C21.0331 25.7144 21.9285 24.8189 21.9285 23.7144V18.0715C21.9285 17.3068 21.4994 16.6424 20.8688 16.3059C20.5386 16.1297 20.1612 16.3038 19.8714 16.5404C19.41 16.9171 18.8206 17.143 18.1786 17.143C17.4818 17.143 16.8472 16.877 16.3707 16.4409Z",
    fill: "#A1A3B2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.75,
    cy: 13.3929,
    r: 1.92856,
    stroke: "white",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1786,
    cy: 13.3929,
    r: 1.92856,
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 16.8969L22.9786 18.4643C22.6611 18.6407 22.4642 18.9753 22.4642 19.3385V21.8502C22.4642 22.2454 22.697 22.6035 23.0581 22.764L25.8795 24.018C26.5408 24.3119 27.2856 23.8278 27.2856 23.1042V17.771C27.2856 17.0086 26.4665 16.5266 25.8 16.8969Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseWalk1);
export default __webpack_public_path__ + "static/media/course_walk_1.8849878c.svg";
export { ForwardRef as ReactComponent };